import {
  ForkEffect,
  put,
  PutEffect,
  select,
  SelectEffect,
  takeEvery,
} from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { type RootState } from '..';
import { addManualPacketResponse } from '../packets/reducer';
import { send } from '../send-request';
import {
  orderCreateInvoice,
  orderFakturoidSyncContact,
  orderFakturoidSyncContactResponse,
  orderHistoryLoad,
  orderLoad,
  orderLoadCustomer,
  orderLoadResponse,
  orderNoteAdd,
  orderSetAttachmentPublic,
  orderSetAttachmentPublicResponse,
  orderSetOrderStatusCode,
  orderUpdateAddress,
  orderVerifyVatId,
  orderVerifyVatIdResponse,
  reviewSentToCustomer,
  reviewSetStatusCode,
  saveOrderTags,
  sentShippedToCustomer,
  sentShippingTimeToCustomer,
  warehousePlaceOrder,
  warehousePlaceOrderResponse,
} from './reducer';

const historyRefreshTriggers: string[] = [
  orderLoadResponse.type,
  orderSetAttachmentPublicResponse.type,
  orderFakturoidSyncContactResponse.type,
  orderVerifyVatIdResponse.type,
  warehousePlaceOrderResponse.type,
  addManualPacketResponse.type,
];

export function* reloadOrderHistory(): Generator<
  SelectEffect | PutEffect,
  void,
  string | undefined
> {
  const orderUUID: string | undefined = yield select(
    (state: RootState): string | undefined => state.Order.order?.uuid,
  );

  if (orderUUID) {
    yield put(orderHistoryLoad(orderUUID));
  }
}

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(orderCreateInvoice.type, send, socket);
  yield takeEvery(orderFakturoidSyncContact.type, send, socket);
  yield takeEvery(orderLoad.type, send, socket);
  yield takeEvery(orderLoadCustomer.type, send, socket);
  yield takeEvery(saveOrderTags.type, send, socket);
  yield takeEvery(orderSetAttachmentPublic.type, send, socket);
  yield takeEvery(reviewSentToCustomer.type, send, socket);
  yield takeEvery(sentShippedToCustomer.type, send, socket);
  yield takeEvery(orderSetOrderStatusCode.type, send, socket);
  yield takeEvery(reviewSetStatusCode.type, send, socket);
  yield takeEvery(sentShippingTimeToCustomer.type, send, socket);
  yield takeEvery(orderUpdateAddress.type, send, socket);
  yield takeEvery(orderVerifyVatId.type, send, socket);
  yield takeEvery(warehousePlaceOrder.type, send, socket);
  yield takeEvery(orderHistoryLoad.type, send, socket);
  yield takeEvery(orderNoteAdd.type, send, socket);
  yield takeEvery(historyRefreshTriggers, reloadOrderHistory);
}
